import { AxiosPromise } from 'axios'
import {
  DeleteVoucherResponse,
  GetVouchers,
  GetVoucherStats,
  UploadVoucherResponse
} from 'types/api/faber/vouchers.type'

import FaberApi from '.'

class VouchersAPI {
  /**
   * To get the list of vouchers
   */
  static getAllVouchers(
    faberToken: string,
    page: number,
    pageSize?: number
  ): AxiosPromise<GetVouchers> {
    const pgSize = pageSize ? `&page_size=${pageSize}` : ''
    return FaberApi.httpGet(
      `/vouchers?page=${page}${pgSize}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  /**
   * To get current voucher stats
   */
  static getVoucherStats(faberToken: string): AxiosPromise<GetVoucherStats> {
    return FaberApi.httpGet(
      '/vouchers/summary',
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  /**
   * For ops to mass upload new vouchers via CSV
   * @param uploadObject
   * @returns
   */
  static createVouchers(body: {
    uploadObject: { data: VouchersCSVData[] }
    faberToken: string
  }): AxiosPromise<UploadVoucherResponse> {
    return FaberApi.httpPost(
      `/vouchers/upload`,
      { Authorization: `Bearer ${body.faberToken}` },
      body.uploadObject
    )
  }

  /**
   * For ops to mass delete vouchers
   *
   */

  static deleteVouchers(
    faberToken: string
  ): AxiosPromise<DeleteVoucherResponse> {
    return FaberApi.httpDelete(`/vouchers`, {
      Authorization: `Bearer ${faberToken}`
    })
  }
}

export default VouchersAPI

interface VouchersCSVData {
  expiryAt: string
  code: string
  currency: string
  value: number
  symbol: string
  partnerName: string
}
